'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hasTouch = require('@zippytech/has-touch');

var _hasTouch2 = _interopRequireDefault(_hasTouch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileTest = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(global.navigator ? global.navigator.userAgent : ''); /**
                                                                                                                                             * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                             *
                                                                                                                                             * This source code is licensed under the MIT license found in the
                                                                                                                                             * LICENSE file in the root directory of this source tree.
                                                                                                                                             */
exports.default = _hasTouch2.default && mobileTest;